/* eslint-disable default-case */
import React from "react";
import {
  Typography,
  ListItemIcon,
  List,
  ListItemText,
  ListItem,
  Box, useTheme
} from '@mui/material';
import { confirmAlert } from "react-confirm-alert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom'

import { fileActions, workflowActions, addTitleLegoCurrent } from "../../store/actions"
import { useStyles } from "./DocumentSignStyles";
import { ReactComponent as ImageSign } from "../../assets/signDoc.svg";
import { CustomAlert, CustomLoadingOverlay, GenericContainer, CustomAlertMaterial, Buttons } from "../../components";
import { ClearSession, coreFunctions } from '../../utils';
import { useTranslation } from 'react-i18next';

export default function SignHelp(props) {
  const { useState, useEffect } = React;
  const gridContainer = {} //mainStyles.gridStyle();
  const navigate = useNavigate();
  const localStyles = useStyles();
  const theme = useTheme()
  const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)

  const [stageName, setStageName] = useState("");
  const [docType, setDocType] = useState([]);
  const [currentStage, setCurrentStage] = useState(0);
  const [totalStage, setTotalStage] = useState(0);
  const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 

  const [cancelAlert, setCancelAlert] = useState(false)
  const [cancelAction, setCancelAction] = useState(false);
  const { t } = useTranslation();

  //Redux hooks
  const auth = useSelector(state => state.Authentication)
  const file = useSelector((state) => state.FileInfo)
  const wf = useSelector((state) => state.Workflow)
  const cancelWF = useSelector(state => state.CancelWorkFlow)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(addTitleLegoCurrent(t("legal_title")))
    console.log("location.state", location.state)
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    setLoadView(true)
  }, []);

  useEffect(() => {
    if (file.items != undefined && loadView) {
      setDocType(JSON.parse(sessionStorage.getItem('properties')))
      getStageProperties(file.items);
      setLoadView(false)
    }
  }, [file]);

  useEffect(() => {
    if (cancelWF.items != undefined && cancelAction) {
      setLoadView(false)
      console.log("cancelWF.items*********************: ", cancelWF.items)
      if (cancelWF.items?.Stage != null) {
        let nextStage = cancelWF.items?.Stage
        let stageName = nextStage.Name
        let stageId = nextStage.Id
        let folioId = file.items.Id
        let stage = cancelWF.items?.Stage

        let nextComponent = coreFunctions.GetLegoNext(stageName)
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
      }
    }
  }, [cancelWF])

  let getStageProperties = (element) => {
    // let stageName = element.Stage.Name;
    // let stageId = element.Stage.Id;
    setTotalStage(element.Stage.TotalStageGroups);
    setCurrentStage(element.Stage.CurrentStageGroup);
    dispatch(addTitleLegoCurrent(element.Stage.Description))
    // setStageName(element.Stage.Description);

    // if (wf.items != undefined) {
    //   let items = wf.items;
    //   items.forEach((i) => {
    //     let stages = i.Stages;
    //     let stgPrp = stages.find(
    //       (j) => j.Id === stageId && j.Name === stageName
    //     );

    //     setTotalStage(stgPrp.TotalStageGroups);
    //     setCurrentStage(stgPrp.CurrentStageGroup);
    //     setStageName(stgPrp.Description);
    //   });
    // }
  };

  // let handleCancelButton = () => {
  //   confirmAlert({
  //     customUI: ({ onClose }) => (
  //       <CustomAlert
  //         title="Cancelar solicitud"
  //         body="Sí no estás de acuerdo con la firma autógrafa en mensaje de datos, no podrás continuar con el trámite"
  //         leftButtonText="Continuar"
  //         leftButtonAction={() => handleModalButton("continue", onClose)}
  //         rightButtonText="Salir"
  //         rightButtonAction={() => handleModalButton("close", onClose)}
  //       />
  //     ),
  //   });
  // };

  // let handleModalButton = (button, onClose) => {
  //   console.log(button);
  //   onClose();
  //   switch (button) {
  //     case "close":
  //       // sessionStorage.clear();
  //       // localStorage.clear();
  //       ClearSession()
  //       persistence.EndSession();
  //       navigate("/auth/");
  //       break;
  //     case "continue":
  //       break;
  //   }
  // };

  let handleSignButton = () => {
    let nextStage = file.items.Stage
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = file.items.Id
    let stage = file.items.Stage
    let nextComponent = "CanvasPdfSignComponent"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })


    // navigate({
    //   pathname: "/CanvasPdfSignComponent"
    // })
  }

  return (<GenericContainer>
    {/* <Typography
      variant="h6"
      gutterBottom
      className={localStyles.stageTitle}
    >
      {stageName}
    </Typography> */}
    <Typography
      variant="subtitle1"
      gutterBottom
      // className={localStyles.stageSubtitle}
    >
      {t("legal_sign_use")}
    </Typography>

    <ImageSign className={localStyles.imgSign} />

    <List dense={true} disablePadding={true}>
      {docType.map((i) => {
        return (
          <ListItem dense={true} disableGutters={true}>
            <ListItemIcon>
              <CheckCircleIcon style={{ fill: "#89C34A" }} />
            </ListItemIcon>
            <ListItemText
              className={localStyles.listText}
              primary={i.Name}
            />
          </ListItem>
        );
      })}
    </List>

    <Buttons 
    /* onClickCancel={() => {
      setCancelAlert(true)
    }} */
      ConfirmButtonText={t("legal_sign")}
      onClickConfirm={handleSignButton}
    />

    {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
    {cancelAlert &&
      <CustomAlertMaterial
        title={t("autograph_signature")}
        body={t("applicant_on_cancel")}
        closeAction={() => setCancelAlert(false)}
        open={cancelAlert}
        leftButtonText={t("general_cancel")}
        leftButtonAction={() => setCancelAlert(false)}
        rightButtonText={t("general_accept")}
        rightButtonAction={() => {
          setCancelAction(true)
          setLoadView(true)
          dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
        }}
      />
    }
  </GenericContainer>);
}
